import React from 'react';
import {Link} from 'react-router-dom';
class PostPreview extends React.Component{

    render(){
        return(
            <div className="row d-flex flex-wrap mt-3">
                {this.props.posts.map((post,index) =>(
                    <div className="col-xs-12 col-md-6 mb-3" key={index}>
                        <Link to={`/noticia/${post.slug}`}>
                            <div className="fila relativo">            
                                <img src={post.url_image} className="imagefull" alt="{post.title"/>
                                <div className="noticialink d-flex align-items-center p-2">
                                    <div className="fila">
                                    <section className="col-12 text-center">
                                        <h2 className="noticiatitulo">{post.title}</h2>
                                    </section>
                                    </div>
                                </div>
                            </div>
                        </Link>
                    </div>
                ))}
            </div>
        )
    }
}

export default PostPreview;